/**
 * What a CV upload accepts, shared by every screen that offers one so the CV
 * page and the apply dialog cannot disagree. The server enforces the same
 * limits; these only spare the student a round trip.
 */
export const RESUME_MAX_SIZE = 5 * 1024 * 1024;
export const RESUME_ACCEPT = '.pdf,.doc,.docx,application/pdf';
export const RESUME_HINT = 'PDF, DOC or DOCX · max 5 MB';
